module.exports = __webpack_public_path__ + "scripts/outline-icons.eot?859001f6";


//////////////////
// WEBPACK FOOTER
// ./semantic/dist/themes/default/assets/fonts/outline-icons.eot
// module id = 91
// module chunks = 1